import { Download, X } from 'lucide-react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Full-screen photo viewer, opened from a chat bubble so the admin never leaves the inbox.
 * Closes on Escape, the X, or a click on the dark backdrop.
 * @param {{url: string, alt?: string, onClose: () => void}} props
 */
const ImageLightbox = ({ url, alt = 'Photo', onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Photo viewer"
      className="fixed inset-0 z-[100] flex flex-col bg-black/90"
      onClick={onClose}
    >
      <div className="flex items-center justify-end gap-2 p-3 text-white">
        <a
          href={url}
          download
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download photo"
          onClick={(e) => e.stopPropagation()}
          className="rounded-full p-2 hover:bg-white/10"
        >
          <Download size={20} />
        </a>
        <button type="button" aria-label="Close photo" onClick={onClose} className="rounded-full p-2 hover:bg-white/10">
          <X size={20} />
        </button>
      </div>
      <div className="flex min-h-0 flex-1 items-center justify-center p-4">
        <img
          src={url}
          alt={alt}
          onClick={(e) => e.stopPropagation()}
          className="max-h-full max-w-full object-contain"
        />
      </div>
    </div>,
    document.body,
  );
};

export default ImageLightbox;
